"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _analyticsHelpers = require("../../analytics/analyticsHelpers");

var _default = {
  identify: {},
  page: {},
  elements: {
    // Footer - Unauth and Auth
    'footer--copyright-link-*': (0, _analyticsHelpers.itemClicked)('Footer'),
    'footer--social-icons-*': (0, _analyticsHelpers.itemClicked)('Footer'),
    // Unauth Footer
    // Auth Footer
    'footer--sitemap-item-*': (0, _analyticsHelpers.itemClicked)('Auth Footer'),
    'footer--sitemap-item-business-center-phone': (0, _analyticsHelpers.itemClicked)('Auth Footer', '<<attributes.data-track-description.value>>', {
      phoneNumber: '<<attributes.data-track-phonenumber.value>>'
    }),
    'footer--phone-number': (0, _analyticsHelpers.itemClicked)('Auth Footer'),
    'footer--tdd-tty-link': (0, _analyticsHelpers.itemClicked)('Auth Footer'),
    'footer--business-care-email': (0, _analyticsHelpers.itemClicked)('Auth Footer'),
    'footer--download-app': (0, _analyticsHelpers.itemClicked)('Auth Footer', 'Download the app'),
    'footer--link-ios': (0, _analyticsHelpers.itemClicked)('Auth Footer', 'App Store'),
    'footer--link-android': (0, _analyticsHelpers.itemClicked)('Auth Footer', 'Google Play')
  }
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/footer/footerAnalytics.js
// module id = 3652
// module chunks = 25